// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =====================================================================
   MODERN CAREERS PORTAL WITH WIZARD - Complete Styles
   ===================================================================== */

/* Main Container */
.careers-container {
    min-height: 100vh;
    background: #f8fafc;
}

/* Header with Logo */
.careers-header {
    background: #fff;
    padding: 20px 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    margin-bottom: 0;
}

.logo-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 24px;
}

.company-logo {
    height: 60px;
    width: auto;
    cursor: pointer;
    transition: transform 0.3s ease;
}

    .company-logo:hover {
        transform: scale(1.05);
    }

/* Hero Section */
.hero-section {
    background: linear-gradient(135deg, #1e67e6 0%, #0f4c9e 100%);
    padding: 80px 24px;
    color: #fff;
    position: relative;
    overflow: hidden;
}

    .hero-section::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
        animation: pulse 8s ease-in-out infinite;
    }

@keyframes pulse {
    0%, 100% {
        opacity: 0.5;
    }

    50% {
        opacity: 1;
    }
}

.hero-content {
    max-width: 1400px;
    margin: 0 auto;
    text-align: center;
    position: relative;
    z-index: 1;
}

.hero-title {
    font-size: 3.5rem;
    font-weight: 800;
    margin: 0 0 20px 0;
    color: #fff;
    line-height: 1.2;
    animation: fadeInUp 0.8s ease-out;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.hero-subtitle {
    font-size: 1.25rem;
    margin: 0 0 48px 0;
    opacity: 0.95;
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    animation: fadeInUp 0.8s ease-out 0.2s both;
}

.hero-stats {
    display: flex;
    gap: 60px;
    justify-content: center;
    flex-wrap: wrap;
    animation: fadeInUp 0.8s ease-out 0.4s both;
}

.stat-item {
    display: flex;
    align-items: center;
    gap: 16px;
}

.stat-icon {
    font-size: 48px;
    opacity: 0.9;
}

.stat-number {
    font-size: 2.5rem;
    font-weight: 800;
    line-height: 1;
    margin-bottom: 4px;
}

.stat-label {
    font-size: 0.95rem;
    opacity: 0.9;
}

/* Search Section */
.search-section {
    max-width: 1400px;
    margin: -40px auto 60px;
    padding: 0 24px;
    position: relative;
    z-index: 10;
}

    .search-section .ant-row {
        background: #fff;
        padding: 24px;
        border-radius: 16px;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    }

    .search-section .ant-input-lg {
        height: 56px;
        border-radius: 12px;
        font-size: 16px;
    }

    .search-section .ant-select-lg .ant-select-selector {
        height: 56px !important;
        border-radius: 12px !important;
        display: flex;
        align-items: center;
    }

/* Jobs Grid */
.jobs-grid {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 24px 80px;
}

/* Job Card */
.job-card {
    height: 100%;
    border-radius: 16px;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid #e5e7eb;
    background: #fff;
    cursor: pointer;
}

    .job-card:hover {
        transform: translateY(-8px);
        box-shadow: 0 20px 40px rgba(30, 103, 230, 0.15);
        border-color: #1e67e6;
    }

.job-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
}

/* Job Card Image */
.job-card-image-wrapper {
    position: relative;
    height: 200px;
    overflow: hidden;
    background: linear-gradient(135deg, #f0f4f8 0%, #e5e7eb 100%);
}

.job-card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
}

.job-card:hover .job-card-image {
    transform: scale(1.1);
}

.job-card-image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to bottom, transparent 0%, rgba(30, 103, 230, 0.9) 100%);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 24px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.job-card:hover .job-card-image-overlay {
    opacity: 1;
}

.job-card-icon {
    font-size: 40px;
    color: #fff;
}

.job-card-placeholder {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #1e67e6 0%, #0f4c9e 100%);
}

.placeholder-icon {
    font-size: 64px;
    color: rgba(255, 255, 255, 0.9);
}

/* Job Card Body */
.job-card-body {
    padding: 24px;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.job-card-title {
    margin: 0 0 16px 0 !important;
    color: #1e67e6 !important;
    font-size: 1.25rem !important;
    font-weight: 700 !important;
    line-height: 1.3 !important;
}

.job-card-tag {
    margin-bottom: 12px;
    font-weight: 600;
    border-radius: 6px;
}

.job-card-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
    padding: 16px 0;
    border-top: 1px solid #e5e7eb;
    border-bottom: 1px solid #e5e7eb;
}

    .job-card-details .ant-typography {
        margin: 0;
        color: #6b7280;
        font-size: 14px;
    }

    .job-card-details .anticon {
        color: #1e67e6;
        margin-right: 8px;
    }

.job-card-summary {
    color: #6b7280;
    font-size: 14px;
    line-height: 1.6;
    margin: 0 0 20px 0 !important;
    flex: 1;
}

.job-card-button {
    margin-top: auto;
    height: 48px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    border-radius: 12px !important;
    background: linear-gradient(135deg, #1e67e6 0%, #0f4c9e 100%) !important;
    border: none !important;
}

    .job-card-button:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 8px 20px rgba(30, 103, 230, 0.4) !important;
    }

/* No Results */
.no-results {
    text-align: center;
    padding: 60px 24px;
    background: #fff;
    border-radius: 16px;
    border: 2px dashed #e5e7eb;
}

/* Application Card (Job Detail) */
.application-card {
    border-radius: 16px !important;
    border: 1px solid #e5e7eb !important;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
    overflow: hidden !important;
}

.application-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
    flex-wrap: wrap;
    gap: 16px;
}

/* Job Description */
.job-description {
    line-height: 1.8;
    color: #374151;
}

    .job-description h1,
    .job-description h2,
    .job-description h3,
    .job-description h4 {
        color: #1e67e6;
        margin-top: 24px;
        margin-bottom: 12px;
        font-weight: 700;
    }

    .job-description ul,
    .job-description ol {
        padding-left: 28px;
        margin: 16px 0;
    }

    .job-description li {
        margin: 8px 0;
    }

    .job-description p {
        margin: 12px 0;
    }

/* Wizard Steps */
.ant-steps {
    margin-bottom: 48px !important;
}

.ant-steps-item-icon {
    background: #fff !important;
    border-color: #d1d5db !important;
}

.ant-steps-item-process .ant-steps-item-icon {
    background: #1e67e6 !important;
    border-color: #1e67e6 !important;
}

.ant-steps-item-finish .ant-steps-item-icon {
    background: #10b981 !important;
    border-color: #10b981 !important;
}

    .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon {
        color: #fff !important;
    }

.ant-steps-item-process .ant-steps-item-icon .ant-steps-icon {
    color: #fff !important;
}

.ant-steps-item-title {
    font-weight: 600 !important;
}

.ant-steps-item-description {
    font-size: 13px !important;
}

/* Wizard Cards */
.ant-card-head {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;
    border-bottom: 2px solid #e5e7eb !important;
}

.ant-card-head-title {
    font-weight: 600 !important;
    color: #1e67e6 !important;
}

/* Form Elements */
.ant-form-item-label > label {
    font-weight: 600;
    color: #374151;
}

.ant-input-lg,
.ant-input-number-lg,
.ant-picker-large {
    height: 48px !important;
    border-radius: 10px !important;
    font-size: 15px !important;
}

.ant-input-affix-wrapper-lg {
    padding: 12px 16px !important;
    border-radius: 10px !important;
}

.ant-input-prefix {
    color: #1e67e6 !important;
    font-size: 18px !important;
}

/* Upload */
.ant-upload-list-picture-card-container {
    width: 150px !important;
    height: 150px !important;
}

.ant-upload-select-picture-card {
    width: 150px !important;
    height: 150px !important;
    border-radius: 12px !important;
    border: 2px dashed #d1d5db !important;
    background: #f9fafb !important;
}

    .ant-upload-select-picture-card:hover {
        border-color: #1e67e6 !important;
    }

/* Text Area */
.ant-input-textarea-show-count::after {
    float: right;
    color: #9ca3af;
    font-size: 13px;
}

/* Alert Success */
.ant-alert-success {
    border-radius: 10px !important;
    background: #d1fae5 !important;
    border: 1px solid #6ee7b7 !important;
}

/* Question Cards */
.ant-card-small > .ant-card-head {
    padding: 12px 16px !important;
    background: #f8fafc !important;
}

.ant-card-small > .ant-card-body {
    padding: 16px !important;
}

/* Buttons */
.ant-btn-lg {
    height: 48px !important;
    padding: 0 32px !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    border-radius: 10px !important;
}

.ant-btn-primary {
    background: linear-gradient(135deg, #1e67e6 0%, #0f4c9e 100%) !important;
    border: none !important;
    box-shadow: 0 4px 12px rgba(30, 103, 230, 0.3) !important;
}

    .ant-btn-primary:hover:not(:disabled) {
        background: linear-gradient(135deg, #0f4c9e 0%, #1e67e6 100%) !important;
        transform: translateY(-2px) !important;
        box-shadow: 0 6px 20px rgba(30, 103, 230, 0.4) !important;
    }

.ant-btn-default {
    border: 1px solid #d1d5db !important;
}

    .ant-btn-default:hover:not(:disabled) {
        border-color: #1e67e6 !important;
        color: #1e67e6 !important;
    }

/* Radio & Checkbox */
.ant-radio-wrapper,
.ant-checkbox-wrapper {
    font-size: 15px;
    padding: 8px 0;
}

.ant-radio-checked .ant-radio-inner {
    border-color: #1e67e6 !important;
    background-color: #1e67e6 !important;
}

.ant-checkbox-checked .ant-checkbox-inner {
    background-color: #1e67e6 !important;
    border-color: #1e67e6 !important;
}

/* Tags */
.ant-tag {
    border-radius: 6px;
    padding: 4px 12px;
    font-weight: 600;
    font-size: 13px;
}

/* Divider */
.ant-divider {
    margin: 32px 0 !important;
    border-color: #e5e7eb !important;
}

/* Focus States */
.ant-input:focus,
.ant-input-focused,
.ant-input-affix-wrapper:focus,
.ant-input-affix-wrapper-focused,
.ant-select-focused .ant-select-selector,
.ant-picker-focused {
    border-color: #1e67e6 !important;
    box-shadow: 0 0 0 2px rgba(30, 103, 230, 0.1) !important;
}

/* Loading */
.ant-spin {
    color: #1e67e6 !important;
}

.ant-spin-dot-item {
    background-color: #1e67e6 !important;
}

/* Empty State */
.ant-empty-description {
    color: #6b7280;
}

/* Message */
.ant-message-notice-content {
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Back Button */
.ant-btn[style*="marginBottom"] {
    border-radius: 10px !important;
}

/* Responsive Design */
@media (max-width: 768px) {
    .hero-section {
        padding: 60px 16px;
    }

    .hero-title {
        font-size: 2.5rem;
    }

    .hero-subtitle {
        font-size: 1rem;
    }

    .hero-stats {
        gap: 32px;
        flex-direction: column;
    }

    .stat-item {
        justify-content: center;
    }

    .stat-number {
        font-size: 2rem;
    }

    .company-logo {
        height: 50px;
    }

    .search-section {
        margin-top: -20px;
        padding: 0 16px;
    }

        .search-section .ant-row {
            padding: 16px;
        }

    .jobs-grid {
        padding: 0 16px 60px;
    }

    .job-card-image-wrapper,
    .job-card-placeholder {
        height: 160px;
    }

    .placeholder-icon {
        font-size: 48px;
    }

    .job-card-body {
        padding: 20px;
    }

    .ant-steps {
        margin-bottom: 32px !important;
    }

    .ant-card-head-title {
        font-size: 15px !important;
    }
}

/* Scrollbar */
::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-track {
    background: #f1f5f9;
}

::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #1e67e6 0%, #0f4c9e 100%);
    border-radius: 5px;
}

    ::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(135deg, #0f4c9e 0%, #1e67e6 100%);
    }

/* Print Styles */
@media print {
    .hero-section,
    .search-section,
    .careers-header {
        display: none;
    }

    .application-card {
        box-shadow: none !important;
        border: 1px solid #000 !important;
    }
}

/* Question rows (Health, Work Authorisation, Criminal History): label beside a 130px answer box.
   Same values as the former inline QROW_WRAP / QROW_LABEL / QROW_ANSWER objects. */
.careers-qrow {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 10px 12px;
    border-bottom: 1px solid #f0f0f0;
}

.careers-qrow-label {
    flex: 1;
    font-size: 14px;
    line-height: 1.45;
}

.careers-qrow .careers-qrow-answer {
    margin-bottom: 0;
    width: 130px;
    flex: none;
}

/* Phones only: stack label over a full-width answer box (the detail box already sits below the row),
   let card titles wrap instead of the ellipsis, and truncate the signed-in staff name in the top bar. */
@media (max-width: 576px) {
    .careers-qrow {
        flex-direction: column;
        align-items: stretch;
        gap: 8px;
    }

    .careers-qrow-label {
        flex: none;
    }

    .careers-qrow .careers-qrow-answer {
        width: 100%;
    }

    .ant-card .ant-card-head-title {
        white-space: normal !important;
        overflow: visible !important;
        text-overflow: clip !important;
    }

        .ant-card .ant-card-head-title .ant-space,
        .ant-card .ant-card-head-title .ant-space-item {
            min-width: 0;
        }

    /* Top bar: logo + Jobs + Internal Jobs + Help are wider than a phone, so the bar wraps onto two rows
       (button text kept), the side padding tightens, and only the staff name shrinks. The wizard measures the
       bar's real height when it scrolls (goToStep), so the taller bar never hides a step heading. */
    .careers-topnav {
        flex-wrap: wrap;
        row-gap: 6px;
        padding-left: 12px !important;
        padding-right: 12px !important;
    }

    /* Wizard Previous / Save Draft / Next-Submit row: wraps instead of pushing the page sideways (Review step). */
    .careers-wizard-nav {
        flex-wrap: wrap;
        gap: 8px;
    }

    .careers-topnav-right.ant-space {
        flex-shrink: 1 !important;
        min-width: 0;
        max-width: 100%;
        margin-left: auto;
    }

        .careers-topnav-right .ant-space-item:has(.careers-topnav-name) {
            min-width: 0;
        }

        .careers-topnav-right .ant-space:has(> .ant-space-item > .careers-topnav-name) {
            display: flex;
            min-width: 0;
        }

    .careers-topnav-name {
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
`, "",{"version":3,"sources":["webpack://./ClientApp/careers/Careers.css"],"names":[],"mappings":"AAAA;;0EAE0E;;AAE1E,mBAAmB;AACnB;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,gBAAgB;IAChB,eAAe;IACf,yCAAyC;IACzC,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,+BAA+B;AACnC;;IAEI;QACI,sBAAsB;IAC1B;;AAEJ,iBAAiB;AACjB;IACI,6DAA6D;IAC7D,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;IAEI;QACI,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,8KAA8K;QAC9K,wCAAwC;IAC5C;;AAEJ;IACI;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;IAEI;QACI,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,0CAA0C;IAC9C;;IAEA;QACI,YAAY;QACZ,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,8BAA8B;QAC9B,aAAa;QACb,mBAAmB;IACvB;;AAEJ,cAAc;AACd;IACI,iBAAiB;IACjB,cAAc;IACd,oBAAoB;AACxB;;AAEA,aAAa;AACb;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,iDAAiD;IACjD,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;IAEI;QACI,2BAA2B;QAC3B,gDAAgD;QAChD,qBAAqB;IACzB;;AAEJ;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,6DAA6D;AACjE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oFAAoF;IACpF,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,aAAa;IACb,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6DAA6D;AACjE;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,6BAA6B;IAC7B,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,gCAAgC;AACpC;;IAEI;QACI,SAAS;QACT,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,iBAAiB;IACrB;;AAEJ;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;IAC9B,wEAAwE;IACxE,uBAAuB;AAC3B;;IAEI;QACI,sCAAsC;QACtC,yDAAyD;IAC7D;;AAEJ,eAAe;AACf;IACI,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA,kCAAkC;AAClC;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,qDAAqD;IACrD,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA,oBAAoB;AACpB;IACI,gBAAgB;IAChB,cAAc;AAClB;;IAEI;;;;QAII,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;;QAEI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;AAEJ,iBAAiB;AACjB;IACI,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;;IAEI;QACI,sBAAsB;IAC1B;;AAEJ;IACI,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,iBAAiB;AACjB;IACI,wEAAwE;IACxE,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;;IAGI,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA,WAAW;AACX;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,qCAAqC;IACrC,8BAA8B;AAClC;;IAEI;QACI,gCAAgC;IACpC;;AAEJ,cAAc;AACd;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA,mBAAmB;AACnB;IACI,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,YAAY;AACZ;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,wEAAwE;IACxE,uBAAuB;IACvB,yDAAyD;AAC7D;;IAEI;QACI,wEAAwE;QACxE,sCAAsC;QACtC,yDAAyD;IAC7D;;AAEJ;IACI,oCAAoC;AACxC;;IAEI;QACI,gCAAgC;QAChC,yBAAyB;IAC7B;;AAEJ,qBAAqB;AACrB;;IAEI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA,SAAS;AACT;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,YAAY;AACZ;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA,iBAAiB;AACjB;;;;;;IAMI,gCAAgC;IAChC,wDAAwD;AAC5D;;AAEA,YAAY;AACZ;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA,gBAAgB;AAChB;IACI,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA,gBAAgB;AAChB;IACI,8BAA8B;AAClC;;AAEA,sBAAsB;AACtB;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;QAEI;YACI,aAAa;QACjB;;IAEJ;QACI,oBAAoB;IACxB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,cAAc;AACd;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;IAC7D,kBAAkB;AACtB;;IAEI;QACI,6DAA6D;IACjE;;AAEJ,iBAAiB;AACjB;IACI;;;QAGI,aAAa;IACjB;;IAEA;QACI,2BAA2B;QAC3B,iCAAiC;IACrC;AACJ;;AAEA;mFACmF;AACnF;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,OAAO;IACP,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;;AAEA;wGACwG;AACxG;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,QAAQ;IACZ;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,8BAA8B;QAC9B,4BAA4B;QAC5B,8BAA8B;IAClC;;QAEI;;YAEI,YAAY;QAChB;;IAEJ;;oGAEgG;IAChG;QACI,eAAe;QACf,YAAY;QACZ,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA,8GAA8G;IAC9G;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,yBAAyB;QACzB,YAAY;QACZ,eAAe;QACf,iBAAiB;IACrB;;QAEI;YACI,YAAY;QAChB;;QAEA;YACI,aAAa;YACb,YAAY;QAChB;;IAEJ;QACI,cAAc;QACd,gBAAgB;QAChB,mBAAmB;QACnB,uBAAuB;IAC3B;AACJ","sourcesContent":["/* =====================================================================\r\n   MODERN CAREERS PORTAL WITH WIZARD - Complete Styles\r\n   ===================================================================== */\r\n\r\n/* Main Container */\r\n.careers-container {\r\n    min-height: 100vh;\r\n    background: #f8fafc;\r\n}\r\n\r\n/* Header with Logo */\r\n.careers-header {\r\n    background: #fff;\r\n    padding: 20px 0;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\r\n    margin-bottom: 0;\r\n}\r\n\r\n.logo-container {\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n    padding: 0 24px;\r\n}\r\n\r\n.company-logo {\r\n    height: 60px;\r\n    width: auto;\r\n    cursor: pointer;\r\n    transition: transform 0.3s ease;\r\n}\r\n\r\n    .company-logo:hover {\r\n        transform: scale(1.05);\r\n    }\r\n\r\n/* Hero Section */\r\n.hero-section {\r\n    background: linear-gradient(135deg, #1e67e6 0%, #0f4c9e 100%);\r\n    padding: 80px 24px;\r\n    color: #fff;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n    .hero-section::before {\r\n        content: '';\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        background: radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);\r\n        animation: pulse 8s ease-in-out infinite;\r\n    }\r\n\r\n@keyframes pulse {\r\n    0%, 100% {\r\n        opacity: 0.5;\r\n    }\r\n\r\n    50% {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.hero-content {\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n    text-align: center;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.hero-title {\r\n    font-size: 3.5rem;\r\n    font-weight: 800;\r\n    margin: 0 0 20px 0;\r\n    color: #fff;\r\n    line-height: 1.2;\r\n    animation: fadeInUp 0.8s ease-out;\r\n}\r\n\r\n@keyframes fadeInUp {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(30px);\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.hero-subtitle {\r\n    font-size: 1.25rem;\r\n    margin: 0 0 48px 0;\r\n    opacity: 0.95;\r\n    max-width: 800px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    animation: fadeInUp 0.8s ease-out 0.2s both;\r\n}\r\n\r\n.hero-stats {\r\n    display: flex;\r\n    gap: 60px;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n    animation: fadeInUp 0.8s ease-out 0.4s both;\r\n}\r\n\r\n.stat-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 16px;\r\n}\r\n\r\n.stat-icon {\r\n    font-size: 48px;\r\n    opacity: 0.9;\r\n}\r\n\r\n.stat-number {\r\n    font-size: 2.5rem;\r\n    font-weight: 800;\r\n    line-height: 1;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.stat-label {\r\n    font-size: 0.95rem;\r\n    opacity: 0.9;\r\n}\r\n\r\n/* Search Section */\r\n.search-section {\r\n    max-width: 1400px;\r\n    margin: -40px auto 60px;\r\n    padding: 0 24px;\r\n    position: relative;\r\n    z-index: 10;\r\n}\r\n\r\n    .search-section .ant-row {\r\n        background: #fff;\r\n        padding: 24px;\r\n        border-radius: 16px;\r\n        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\r\n    }\r\n\r\n    .search-section .ant-input-lg {\r\n        height: 56px;\r\n        border-radius: 12px;\r\n        font-size: 16px;\r\n    }\r\n\r\n    .search-section .ant-select-lg .ant-select-selector {\r\n        height: 56px !important;\r\n        border-radius: 12px !important;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n/* Jobs Grid */\r\n.jobs-grid {\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n    padding: 0 24px 80px;\r\n}\r\n\r\n/* Job Card */\r\n.job-card {\r\n    height: 100%;\r\n    border-radius: 16px;\r\n    overflow: hidden;\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    border: 1px solid #e5e7eb;\r\n    background: #fff;\r\n    cursor: pointer;\r\n}\r\n\r\n    .job-card:hover {\r\n        transform: translateY(-8px);\r\n        box-shadow: 0 20px 40px rgba(30, 103, 230, 0.15);\r\n        border-color: #1e67e6;\r\n    }\r\n\r\n.job-card-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n}\r\n\r\n/* Job Card Image */\r\n.job-card-image-wrapper {\r\n    position: relative;\r\n    height: 200px;\r\n    overflow: hidden;\r\n    background: linear-gradient(135deg, #f0f4f8 0%, #e5e7eb 100%);\r\n}\r\n\r\n.job-card-image {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    transition: transform 0.6s ease;\r\n}\r\n\r\n.job-card:hover .job-card-image {\r\n    transform: scale(1.1);\r\n}\r\n\r\n.job-card-image-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: linear-gradient(to bottom, transparent 0%, rgba(30, 103, 230, 0.9) 100%);\r\n    display: flex;\r\n    align-items: flex-end;\r\n    justify-content: center;\r\n    padding: 24px;\r\n    opacity: 0;\r\n    transition: opacity 0.3s ease;\r\n}\r\n\r\n.job-card:hover .job-card-image-overlay {\r\n    opacity: 1;\r\n}\r\n\r\n.job-card-icon {\r\n    font-size: 40px;\r\n    color: #fff;\r\n}\r\n\r\n.job-card-placeholder {\r\n    height: 200px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background: linear-gradient(135deg, #1e67e6 0%, #0f4c9e 100%);\r\n}\r\n\r\n.placeholder-icon {\r\n    font-size: 64px;\r\n    color: rgba(255, 255, 255, 0.9);\r\n}\r\n\r\n/* Job Card Body */\r\n.job-card-body {\r\n    padding: 24px;\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.job-card-title {\r\n    margin: 0 0 16px 0 !important;\r\n    color: #1e67e6 !important;\r\n    font-size: 1.25rem !important;\r\n    font-weight: 700 !important;\r\n    line-height: 1.3 !important;\r\n}\r\n\r\n.job-card-tag {\r\n    margin-bottom: 12px;\r\n    font-weight: 600;\r\n    border-radius: 6px;\r\n}\r\n\r\n.job-card-details {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n    margin-bottom: 16px;\r\n    padding: 16px 0;\r\n    border-top: 1px solid #e5e7eb;\r\n    border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n    .job-card-details .ant-typography {\r\n        margin: 0;\r\n        color: #6b7280;\r\n        font-size: 14px;\r\n    }\r\n\r\n    .job-card-details .anticon {\r\n        color: #1e67e6;\r\n        margin-right: 8px;\r\n    }\r\n\r\n.job-card-summary {\r\n    color: #6b7280;\r\n    font-size: 14px;\r\n    line-height: 1.6;\r\n    margin: 0 0 20px 0 !important;\r\n    flex: 1;\r\n}\r\n\r\n.job-card-button {\r\n    margin-top: auto;\r\n    height: 48px !important;\r\n    font-size: 16px !important;\r\n    font-weight: 600 !important;\r\n    border-radius: 12px !important;\r\n    background: linear-gradient(135deg, #1e67e6 0%, #0f4c9e 100%) !important;\r\n    border: none !important;\r\n}\r\n\r\n    .job-card-button:hover {\r\n        transform: translateY(-2px) !important;\r\n        box-shadow: 0 8px 20px rgba(30, 103, 230, 0.4) !important;\r\n    }\r\n\r\n/* No Results */\r\n.no-results {\r\n    text-align: center;\r\n    padding: 60px 24px;\r\n    background: #fff;\r\n    border-radius: 16px;\r\n    border: 2px dashed #e5e7eb;\r\n}\r\n\r\n/* Application Card (Job Detail) */\r\n.application-card {\r\n    border-radius: 16px !important;\r\n    border: 1px solid #e5e7eb !important;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;\r\n    overflow: hidden !important;\r\n}\r\n\r\n.application-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n    margin-bottom: 24px;\r\n    flex-wrap: wrap;\r\n    gap: 16px;\r\n}\r\n\r\n/* Job Description */\r\n.job-description {\r\n    line-height: 1.8;\r\n    color: #374151;\r\n}\r\n\r\n    .job-description h1,\r\n    .job-description h2,\r\n    .job-description h3,\r\n    .job-description h4 {\r\n        color: #1e67e6;\r\n        margin-top: 24px;\r\n        margin-bottom: 12px;\r\n        font-weight: 700;\r\n    }\r\n\r\n    .job-description ul,\r\n    .job-description ol {\r\n        padding-left: 28px;\r\n        margin: 16px 0;\r\n    }\r\n\r\n    .job-description li {\r\n        margin: 8px 0;\r\n    }\r\n\r\n    .job-description p {\r\n        margin: 12px 0;\r\n    }\r\n\r\n/* Wizard Steps */\r\n.ant-steps {\r\n    margin-bottom: 48px !important;\r\n}\r\n\r\n.ant-steps-item-icon {\r\n    background: #fff !important;\r\n    border-color: #d1d5db !important;\r\n}\r\n\r\n.ant-steps-item-process .ant-steps-item-icon {\r\n    background: #1e67e6 !important;\r\n    border-color: #1e67e6 !important;\r\n}\r\n\r\n.ant-steps-item-finish .ant-steps-item-icon {\r\n    background: #10b981 !important;\r\n    border-color: #10b981 !important;\r\n}\r\n\r\n    .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon {\r\n        color: #fff !important;\r\n    }\r\n\r\n.ant-steps-item-process .ant-steps-item-icon .ant-steps-icon {\r\n    color: #fff !important;\r\n}\r\n\r\n.ant-steps-item-title {\r\n    font-weight: 600 !important;\r\n}\r\n\r\n.ant-steps-item-description {\r\n    font-size: 13px !important;\r\n}\r\n\r\n/* Wizard Cards */\r\n.ant-card-head {\r\n    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%) !important;\r\n    border-bottom: 2px solid #e5e7eb !important;\r\n}\r\n\r\n.ant-card-head-title {\r\n    font-weight: 600 !important;\r\n    color: #1e67e6 !important;\r\n}\r\n\r\n/* Form Elements */\r\n.ant-form-item-label > label {\r\n    font-weight: 600;\r\n    color: #374151;\r\n}\r\n\r\n.ant-input-lg,\r\n.ant-input-number-lg,\r\n.ant-picker-large {\r\n    height: 48px !important;\r\n    border-radius: 10px !important;\r\n    font-size: 15px !important;\r\n}\r\n\r\n.ant-input-affix-wrapper-lg {\r\n    padding: 12px 16px !important;\r\n    border-radius: 10px !important;\r\n}\r\n\r\n.ant-input-prefix {\r\n    color: #1e67e6 !important;\r\n    font-size: 18px !important;\r\n}\r\n\r\n/* Upload */\r\n.ant-upload-list-picture-card-container {\r\n    width: 150px !important;\r\n    height: 150px !important;\r\n}\r\n\r\n.ant-upload-select-picture-card {\r\n    width: 150px !important;\r\n    height: 150px !important;\r\n    border-radius: 12px !important;\r\n    border: 2px dashed #d1d5db !important;\r\n    background: #f9fafb !important;\r\n}\r\n\r\n    .ant-upload-select-picture-card:hover {\r\n        border-color: #1e67e6 !important;\r\n    }\r\n\r\n/* Text Area */\r\n.ant-input-textarea-show-count::after {\r\n    float: right;\r\n    color: #9ca3af;\r\n    font-size: 13px;\r\n}\r\n\r\n/* Alert Success */\r\n.ant-alert-success {\r\n    border-radius: 10px !important;\r\n    background: #d1fae5 !important;\r\n    border: 1px solid #6ee7b7 !important;\r\n}\r\n\r\n/* Question Cards */\r\n.ant-card-small > .ant-card-head {\r\n    padding: 12px 16px !important;\r\n    background: #f8fafc !important;\r\n}\r\n\r\n.ant-card-small > .ant-card-body {\r\n    padding: 16px !important;\r\n}\r\n\r\n/* Buttons */\r\n.ant-btn-lg {\r\n    height: 48px !important;\r\n    padding: 0 32px !important;\r\n    font-size: 16px !important;\r\n    font-weight: 600 !important;\r\n    border-radius: 10px !important;\r\n}\r\n\r\n.ant-btn-primary {\r\n    background: linear-gradient(135deg, #1e67e6 0%, #0f4c9e 100%) !important;\r\n    border: none !important;\r\n    box-shadow: 0 4px 12px rgba(30, 103, 230, 0.3) !important;\r\n}\r\n\r\n    .ant-btn-primary:hover:not(:disabled) {\r\n        background: linear-gradient(135deg, #0f4c9e 0%, #1e67e6 100%) !important;\r\n        transform: translateY(-2px) !important;\r\n        box-shadow: 0 6px 20px rgba(30, 103, 230, 0.4) !important;\r\n    }\r\n\r\n.ant-btn-default {\r\n    border: 1px solid #d1d5db !important;\r\n}\r\n\r\n    .ant-btn-default:hover:not(:disabled) {\r\n        border-color: #1e67e6 !important;\r\n        color: #1e67e6 !important;\r\n    }\r\n\r\n/* Radio & Checkbox */\r\n.ant-radio-wrapper,\r\n.ant-checkbox-wrapper {\r\n    font-size: 15px;\r\n    padding: 8px 0;\r\n}\r\n\r\n.ant-radio-checked .ant-radio-inner {\r\n    border-color: #1e67e6 !important;\r\n    background-color: #1e67e6 !important;\r\n}\r\n\r\n.ant-checkbox-checked .ant-checkbox-inner {\r\n    background-color: #1e67e6 !important;\r\n    border-color: #1e67e6 !important;\r\n}\r\n\r\n/* Tags */\r\n.ant-tag {\r\n    border-radius: 6px;\r\n    padding: 4px 12px;\r\n    font-weight: 600;\r\n    font-size: 13px;\r\n}\r\n\r\n/* Divider */\r\n.ant-divider {\r\n    margin: 32px 0 !important;\r\n    border-color: #e5e7eb !important;\r\n}\r\n\r\n/* Focus States */\r\n.ant-input:focus,\r\n.ant-input-focused,\r\n.ant-input-affix-wrapper:focus,\r\n.ant-input-affix-wrapper-focused,\r\n.ant-select-focused .ant-select-selector,\r\n.ant-picker-focused {\r\n    border-color: #1e67e6 !important;\r\n    box-shadow: 0 0 0 2px rgba(30, 103, 230, 0.1) !important;\r\n}\r\n\r\n/* Loading */\r\n.ant-spin {\r\n    color: #1e67e6 !important;\r\n}\r\n\r\n.ant-spin-dot-item {\r\n    background-color: #1e67e6 !important;\r\n}\r\n\r\n/* Empty State */\r\n.ant-empty-description {\r\n    color: #6b7280;\r\n}\r\n\r\n/* Message */\r\n.ant-message-notice-content {\r\n    border-radius: 10px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n/* Back Button */\r\n.ant-btn[style*=\"marginBottom\"] {\r\n    border-radius: 10px !important;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n    .hero-section {\r\n        padding: 60px 16px;\r\n    }\r\n\r\n    .hero-title {\r\n        font-size: 2.5rem;\r\n    }\r\n\r\n    .hero-subtitle {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .hero-stats {\r\n        gap: 32px;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .stat-item {\r\n        justify-content: center;\r\n    }\r\n\r\n    .stat-number {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .company-logo {\r\n        height: 50px;\r\n    }\r\n\r\n    .search-section {\r\n        margin-top: -20px;\r\n        padding: 0 16px;\r\n    }\r\n\r\n        .search-section .ant-row {\r\n            padding: 16px;\r\n        }\r\n\r\n    .jobs-grid {\r\n        padding: 0 16px 60px;\r\n    }\r\n\r\n    .job-card-image-wrapper,\r\n    .job-card-placeholder {\r\n        height: 160px;\r\n    }\r\n\r\n    .placeholder-icon {\r\n        font-size: 48px;\r\n    }\r\n\r\n    .job-card-body {\r\n        padding: 20px;\r\n    }\r\n\r\n    .ant-steps {\r\n        margin-bottom: 32px !important;\r\n    }\r\n\r\n    .ant-card-head-title {\r\n        font-size: 15px !important;\r\n    }\r\n}\r\n\r\n/* Scrollbar */\r\n::-webkit-scrollbar {\r\n    width: 10px;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n    background: #f1f5f9;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    background: linear-gradient(135deg, #1e67e6 0%, #0f4c9e 100%);\r\n    border-radius: 5px;\r\n}\r\n\r\n    ::-webkit-scrollbar-thumb:hover {\r\n        background: linear-gradient(135deg, #0f4c9e 0%, #1e67e6 100%);\r\n    }\r\n\r\n/* Print Styles */\r\n@media print {\r\n    .hero-section,\r\n    .search-section,\r\n    .careers-header {\r\n        display: none;\r\n    }\r\n\r\n    .application-card {\r\n        box-shadow: none !important;\r\n        border: 1px solid #000 !important;\r\n    }\r\n}\r\n\r\n/* Question rows (Health, Work Authorisation, Criminal History): label beside a 130px answer box.\r\n   Same values as the former inline QROW_WRAP / QROW_LABEL / QROW_ANSWER objects. */\r\n.careers-qrow {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 16px;\r\n    padding: 10px 12px;\r\n    border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.careers-qrow-label {\r\n    flex: 1;\r\n    font-size: 14px;\r\n    line-height: 1.45;\r\n}\r\n\r\n.careers-qrow .careers-qrow-answer {\r\n    margin-bottom: 0;\r\n    width: 130px;\r\n    flex: none;\r\n}\r\n\r\n/* Phones only: stack label over a full-width answer box (the detail box already sits below the row),\r\n   let card titles wrap instead of the ellipsis, and truncate the signed-in staff name in the top bar. */\r\n@media (max-width: 576px) {\r\n    .careers-qrow {\r\n        flex-direction: column;\r\n        align-items: stretch;\r\n        gap: 8px;\r\n    }\r\n\r\n    .careers-qrow-label {\r\n        flex: none;\r\n    }\r\n\r\n    .careers-qrow .careers-qrow-answer {\r\n        width: 100%;\r\n    }\r\n\r\n    .ant-card .ant-card-head-title {\r\n        white-space: normal !important;\r\n        overflow: visible !important;\r\n        text-overflow: clip !important;\r\n    }\r\n\r\n        .ant-card .ant-card-head-title .ant-space,\r\n        .ant-card .ant-card-head-title .ant-space-item {\r\n            min-width: 0;\r\n        }\r\n\r\n    /* Top bar: logo + Jobs + Internal Jobs + Help are wider than a phone, so the bar wraps onto two rows\r\n       (button text kept), the side padding tightens, and only the staff name shrinks. The wizard measures the\r\n       bar's real height when it scrolls (goToStep), so the taller bar never hides a step heading. */\r\n    .careers-topnav {\r\n        flex-wrap: wrap;\r\n        row-gap: 6px;\r\n        padding-left: 12px !important;\r\n        padding-right: 12px !important;\r\n    }\r\n\r\n    /* Wizard Previous / Save Draft / Next-Submit row: wraps instead of pushing the page sideways (Review step). */\r\n    .careers-wizard-nav {\r\n        flex-wrap: wrap;\r\n        gap: 8px;\r\n    }\r\n\r\n    .careers-topnav-right.ant-space {\r\n        flex-shrink: 1 !important;\r\n        min-width: 0;\r\n        max-width: 100%;\r\n        margin-left: auto;\r\n    }\r\n\r\n        .careers-topnav-right .ant-space-item:has(.careers-topnav-name) {\r\n            min-width: 0;\r\n        }\r\n\r\n        .careers-topnav-right .ant-space:has(> .ant-space-item > .careers-topnav-name) {\r\n            display: flex;\r\n            min-width: 0;\r\n        }\r\n\r\n    .careers-topnav-name {\r\n        display: block;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
